/* eslint-disable camelcase */
import { CriticalDatasetLabels, LightConditionsSun, LightConditionsType } from '../../enum'
import Vuetify from '../../plugins/vuetify'

const _t = (text) => Vuetify.framework.lang.t(text)

export class LightConditionsEntry {
  constructor ({ type = LightConditionsType.DAY_TIME, sun = LightConditionsSun.NONE, rain = false } = {}) {
    this.type = type // enums.LightConditionsType
    this.sun = sun // enums.LightConditionsSun
    this.rain = rain // boolean
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      type: this.type,
      sun: this.type !== LightConditionsType.NIGHT_TIME ? this.sun : LightConditionsSun.NONE,
      rain: this.rain
    }
  }

  get textRepresentation () {
    const result = []
    result.push(_t(`$vuetify.criticalDataset.enums.LightConditionsType.${this.type}`))

    if (this.sun !== LightConditionsSun.NONE) {
      result.push(`${_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.LIGHT_CONDITIONS}.sun`)}: ${_t(`$vuetify.criticalDataset.enums.LightConditionsSun.${this.sun}`)}`)
    }

    if (this.rain) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.LIGHT_CONDITIONS}.rainDataset`))
    }

    return result.map(item => ({
      item,
      color: 'orange',
      type: CriticalDatasetLabels.LIGHT_CONDITIONS
    }))
  }
}
